import { Container, Typography, Button, Stack, Grid, Box } from "@mui/material";
import { Verified, Schedule, Checklist, PhotoCamera, Stars } from "@mui/icons-material";

interface HeroProps {
  bgcolor?: string;
  onGetEstimate?: () => void;
}

const strengths = [
  {
    icon: Verified,
    color: '#4CAF50',
    text: 'Verified cleaners',
  },
  {
    icon: Schedule,
    color: '#2196F3',
    text: 'Flexible scheduling',
  },
  {
    icon: Checklist,
    color: '#FF9800',
    text: 'Airbnb-specific checklist',
  },
  {
    icon: PhotoCamera,
    color: '#9C27B0',
    text: 'Photo proof after every clean',
  },
  {
    icon: Stars,
    color: '#FFC107',
    text: 'High quality standards',
  },
];

function Hero({ bgcolor, onGetEstimate }: HeroProps) {
  return (
    <Box sx={{ width: "100%", bgcolor }}>
      <Container
        component="section"
        maxWidth="lg" // Adds space around the Hero section
        sx={{
          py: 4, // Vertical padding
          px: 4, // Horizontal padding
        }}
      >
        <Grid container alignItems="center" spacing={4}>
          {/* Left Side - Text */}
          <Grid item xs={12} md={6}>
            <Stack spacing={4}>
              <Typography variant="h2" fontWeight="bold">
                Short-Term Rental Cleaning in Toronto
              </Typography>
              <Typography variant="h5" color="text.secondary">
                Professional AirBnB turnover cleaning that helps you earn 5-star guest reviews.
              </Typography>
              {/* Strengths List */}
              <Stack spacing={2} alignSelf="center">
                {strengths.map((strength, index) => {
                  const Icon = strength.icon;
                  return (
                    <Box key={index} display="flex" alignItems="center" gap={1}>
                      <Icon fontSize="small" sx={{ color: strength.color }} />
                      <Typography>{strength.text}</Typography>
                    </Box>
                  );
                })}
              </Stack>
              <Stack direction="row" spacing={2} justifyContent="center">
                <Button variant="contained" color="secondary" size="large"
                  onClick={() => {
                    if (onGetEstimate) {
                      onGetEstimate();
                    } else {
                      const section = document.getElementById("quote");
                      if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                      }
                    }
                  }}>
                  Get a Free Estimate
                </Button>
              </Stack>
            </Stack>
          </Grid>

          {/* Right Side - Image */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                width: "100%",
                // height: "100%",
                aspectRatio: "1 / 1",
                minHeight: "400px", // Ensures proper height
                backgroundImage: "url('https://djinni-assets.s3.us-east-1.amazonaws.com/main/hero.jpg')",
                backgroundSize: "cover",         // Show the entire image
                backgroundPosition: "center",
                borderRadius: "8px", // Slightly rounded corners
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default Hero;
